module.exports = __webpack_public_path__ + "static/media/img-banner-aragon.7a69b738.jpg";